import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClinichedatabaseService } from '../../services/clinichedatabase.service';
import { LoaderService } from '../../loader/loader.service';
import { AlertDialogService } from '../../services/alert-dialog.service';
import { Confirm } from "../../dialogs/confirm-dialog/confirm-dialog.component";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import * as moment from 'moment';
import { ExcelService } from '../../services/excel.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

import "moment-timezone";

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';

import { ClinicheDatabase } from '../../entities/datibase/clinichedatabase-model';
import { windowWhen } from 'rxjs/operators';

const tz = "Europe/Rome";
const dateFormat = "YYYY-MM-DDTHH:mm:ss";

const dateFormatDate = "YYYY-MM-DD";
const dateFormatHour = "HH:mm";

@Component({
  selector: 'target3-import',
  templateUrl: './target3-import.component.html',
  styleUrls: ['./target3-import.component.css']
})
export class TargetPImportComponent implements OnInit {
  role: string;
  isAdmin: boolean = false;
  isCA: boolean = false;
  isDC: boolean = false;
  usr: any;
  willDownload = false;

  constructor(public dialogRef: MatDialogRef<TargetPImportComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private dbService: ClinichedatabaseService, private loaderService: LoaderService, private alertDialog: AlertDialogService,
    private fb: FormBuilder, private _sanitizer: DomSanitizer, private http: HttpClient) {

    this.role = data.role;
    this.usr = data.usr;

    if (this.role != null && (this.role.toLowerCase() == 'amministratore' || this.role.toLowerCase() == 'amministratore dp' || this.role.toLowerCase() == 'hr medici')) {
      this.isDC = false;
      this.isAdmin = true;
      this.isCA = false;
    }
    if (this.role != null && (this.role.toLowerCase() == 'direzione commerciale')) {
      this.isDC = true;
      this.isAdmin = false;
      this.isCA = false;
    }
    if (this.role != null && (this.role.toLowerCase() == 'ciclo_attivo' || this.role.toLowerCase() == 'ciclo attivo')) {
      this.isDC = false;
      this.isAdmin = false;
      this.isCA = true;
    }

  }

  parseDateExcel(excelTimestamp) {
    const secondsInDay = 24 * 60 * 60;
    const excelEpoch = new Date(1899, 11, 31);
    const excelEpochAsUnixTimestamp = excelEpoch.getTime();
    const missingLeapYearDay = secondsInDay * 1000;
    const delta = excelEpochAsUnixTimestamp - missingLeapYearDay;
    const excelTimestampAsUnixTimestamp = excelTimestamp * secondsInDay * 1000;
    const parsed = excelTimestampAsUnixTimestamp + delta;
    return isNaN(parsed) ? null : parsed;
  }

  setDownload(data) {
    this.willDownload = true;
    setTimeout(() => {
      const el = document.querySelector("#download");
      el.setAttribute("href", `data:text/json;charset=utf-8,${encodeURIComponent(data)}`);
    }, 1000)
  }

  onFileChange(ev) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    if (this.isAdmin == true || this.isDC == true) {
      if (window.confirm('Vuoi sovrascrivere i dati presenti nel file Excel con quelli nel DB?')) {
        //this.loaderService.show();
        reader.onload = (event) => {
          const data = reader.result;
          workBook = XLSX.read(data, { type: 'binary' });
          jsonData = workBook.SheetNames.reduce((initial, name) => {
            const sheet = workBook.Sheets[name];
            initial[name] = XLSX.utils.sheet_to_json(sheet);
            return initial;
          }, {});
          const dataString = JSON.stringify(jsonData);
          document.getElementById('output').innerHTML = dataString.slice(0, 1000).concat("...");

          let arrayCall = [];

          console.log('jsondata %o', jsonData);

          for (var ito in jsonData['data']) {
            console.log('ito %o', ito);
            let operatore = {};
            operatore['IdFatturazione'] = jsonData['data'][ito]['IdFatturazione'];
            operatore['Mese'] = jsonData['data'][ito]['Mese'];
            operatore['TgProduzioneMese'] = jsonData['data'][ito]['TgProduzioneMese'];
            operatore['Trimestre'] = jsonData['data'][ito]['Trimestre'];
            operatore['TgProduzioneTrimestre'] = jsonData['data'][ito]['TgProduzioneTrimestre'];

            let ret1 = this.http.post(`${environment.gceAPI}/incentive_update_target_medic`, operatore, { responseType: 'json' });
            arrayCall.push(ret1);
          }

          Observable.forkJoin(arrayCall).subscribe(results => {
            this.loaderService.hide();
            window.alert('Import terminato');
            this.dialogRef.close();
          },
            err => {
              this.loaderService.hide();
              console.log('ERR %o', err);
              window.alert('Errore nella procedura di importazione.');
              this.dialogRef.close();
            });
        }
        reader.readAsBinaryString(file);
      }
    }
    else {
      window.alert('Att.ne: il tuo profilo non è abilitato per importare dati da file Excel')
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  ngOnInit() {

  }


}
